<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"EMPLOYEE.VISA.LEGALCOMPLIANCE"|translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column justify-content-center">
    <form action="" class="o-h" [formGroup]="addForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6 mt-3 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.VISA.PASSPORTNO"|translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control"
              placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.VISA.PASSPORTNO' | translate}}"
              formControlName="passport_number">
          </div>
          <mat-error *ngIf="isControlHasError('passport_number','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
        <div class="col-md-6 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.VISA.VISAEXPIREDATE"|translate}}</label>
          <div class="in-box">
            <input class="form-control in-i" [matDatepicker]="startDate" formControlName="ex_dt" />
            <mat-datepicker-toggle matIconSuffix [for]="startDate" class="mat-date"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </div>
          <mat-error *ngIf="isControlHasError('ac_n','required')"> {{"This is required"|translate}}</mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-3 mt-3 mt-lg-4">
          <label for="">Set {{"EMPLOYEE.VISA.PERMITTEDHOUR"|translate}}</label>
          <div class="d-flex flex-wrap align-items-center">
            <mat-radio-group class="d-flex rd-box" formControlName="permitted_hour">
              <div class="d-flex">
                <mat-radio-button class="" value="40"></mat-radio-button>
                <div class="radio-title l-h">40 hour</div>
              </div>
              <div class="d-flex ms-4 rd-l">
                <mat-radio-button class="" value="custom"></mat-radio-button>
                <div class="radio-title  l-h">Custom Hours</div>
              </div>
              <div class="d-flex ms-4 rd-l me-3">
                <mat-radio-button class="" value="default"></mat-radio-button>
                <div class="radio-title  l-h">Under 18</div>
              </div>
            </mat-radio-group>
          </div>
          <div class="form-input mt-3" *ngIf="addForm.value.permitted_hour=='custom'">
            <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.VISA.CUSTOMHOUR' | translate}}"  
            formControlName="custom">
          </div>
          <mat-error *ngIf="isControlHasError('permitted_hour','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.VISA.NATIONALITY"|translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control" formControlName="nationality"
              placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.VISA.NATIONALITY' | translate}}">
          </div>
          <mat-error *ngIf="isControlHasError('nationality','required')"> {{"COMMON.THR"|translate}}
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mt-3 mt-lg-4">
          <label for="">{{"COMMON.NOTES"|translate}}</label>
          <div class="form-input">
            <textarea class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NOTES' | translate}}"
              formControlName="notes"></textarea>
          </div>
          <mat-error *ngIf="isControlHasError('notes','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
        <div class="col-md-12 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.VISA.VISAIMAGE"|translate}}</label>
          <div class="drop-box m-auto  mt-2" style="position:relative">
            <ngx-dropzone class="drop-item" [multiple]="true" (change)="onSelect($event,'visa')"
              accept="image/jpeg,image/jpg,image/png">
              <ngx-dropzone-label>
                <div class="d-box">
                  <div class="me">
                    <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                  </div>
                  <div>
                    <div class="text-left">Click to Upload</div>
                    <div class="upload-text text-left">Or just drag and drop</div>
                  </div>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f,'visa')"
                class="preview">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
          </div>
        </div>
        <mat-error *ngIf="error.visa" class="mt-2"> {{"EMPLOYEE.VISA.ADDVISAERROR"|translate}}</mat-error>
        <div class="col-md-12 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.VISA.PASSPORTIMAGES"|translate}}</label>
          <div class="drop-box m-auto  mt-2" style="position:relative">
            <ngx-dropzone class="drop-item" [multiple]="true" (change)="onSelect($event,'passport')"
              accept="image/jpeg,image/jpg,image/png">
              <ngx-dropzone-label>
                <div class="d-box">
                  <div class="me">
                    <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                  </div>
                  <div>
                    <div class="text-left">Click to Upload</div>
                    <div class="upload-text text-left">Or just drag and drop</div>
                  </div>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of passportFiles" [removable]="true"
                (removed)="onRemove(f,'passport')">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
          </div>
        </div>
        <mat-error *ngIf="error.passport" class="mt-2"> {{"EMPLOYEE.VISA.ADDPASSPORTERROR"|translate}}</mat-error>
      </div>
      <div>
      </div>
    </form>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
        (click)="onSubmit()">{{"BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>